import React from 'react';
import { HStack, Text, Box } from '@skin-seoul/design-system';
interface LegendItemProps {
  color: string;
  label: string;
}
const LegendItem = ({
  color,
  label
}: LegendItemProps) => {
  const getGradient = (color: string) => {
    switch (color) {
      case 'primary.400':
        return 'linear-gradient(to left, #3d1690 71.918%, #12062a 160%)';
      case 'primary.200':
        return 'linear-gradient(to right, #652be0, #976df3)';
      case 'primary.50':
        return 'linear-gradient(to left, #ff6467, #976df3)';
      case 'error.300':
        return '#ff6467';
      default:
        return color;
    }
  };
  return <HStack gap={1} alignItems="center" justifyContent="flex-start" data-sentry-element="HStack" data-sentry-component="LegendItem" data-sentry-source-file="LegendItem.tsx">
      <Box background={getGradient(color)} borderRadius="20px" width="12px" height="12px" flexShrink={0} data-sentry-element="Box" data-sentry-source-file="LegendItem.tsx" />
      <Text textStyle={{
      base: 'label.xsmall',
      tablet: 'label.large'
    }} fontWeight="medium" color="neutral.700" textAlign="left" whiteSpace="nowrap" data-sentry-element="Text" data-sentry-source-file="LegendItem.tsx">
        {label}
      </Text>
    </HStack>;
};
export default LegendItem;